module.exports = __webpack_public_path__ + "img/buyHomeMaskPhone.c33d2ead.png";